import { ref, inject} from 'vue';
import { apiLink } from './apiLink'
import { deleteData, getData, postData, putData, patchData } from './generalio';

const auditData = () => {

    const getAudits = (projectId) => {

        let endPoint = `idleaudit/${projectId}`

        return getData(endPoint, "idle audit", [])
            .catch(err => {
                let msg = "ERROR fn: getAudits: " + err
                console.log(msg)
                throw Error(msg)
            })
    }

    const createAudit = (projectId, description) => {

        let endPoint = `idleaudit/${projectId}`

        return postData(endPoint, description, "idle audit", null)
            .then(r => {
                if (r != null && r != undefined) {
                    return r
                }

                throw Error("Audit postData had bad data fed into the /idleaudit/{id} end point " +
                    JSON.stringify(r))
            })
            .catch(err => {
                let msg = "ERROR fn: createAudit: " + err
                console.log(msg)
                throw Error(msg)
            })
    }

    return {getAudits, createAudit}
}

export default auditData
